import CryptoWalletIcon from './cryptoWallet.svg';
import DeFiIcon from './DeFi.svg';
import MultipleNetworksIcon from './multipleNetworks.svg';
import NFTIcon from './NFT.svg';

export { CryptoWalletIcon, DeFiIcon, MultipleNetworksIcon, NFTIcon };
